import React, { useState } from 'react';

import { Alert, Box, Button, Grid, Stack, Typography } from '@mui/material';
import KpiComponent from '@/components/Base/KpiComponent';
import { useConsolidationSummary } from '@/features/dashboard/api/getConsolidationSummary.ts';
import CurrencyFormat from '@/utils/CurrencyFormat.ts';
import dayjs from 'dayjs';
import ImportCountDefault from '@/components/Base/ImportCountDefault';
import { useNavigate } from 'react-router-dom';
import ScoreInadimplenciaCategoriaVisao from '@/features/dashboard/ScoreInadimplenciaCategoriaVisao';
import ScoreInadimplenciaCategoriaVisaoAnual from '@/features/dashboard/ScoreInadimplenciaCategoriaVisaoAnual';
import LoadingSummary from '@/features/dashboard/components/LoadingSummary';
import PeriodFilterYearMonthy from '@/components/Base/PeriodFilterYearMonthy';
import { TitlePages } from '@/components/Base/TitlePage';
import { useInadimplenciaHistoricalOverview } from '@/features/inadimplencia/api/getInadimplenciaHistoricalOverview';
import PeriodFilterDash from '@/components/Base/PeriodFilterDash';

export const InadimplenciaVisaoHistorica = () => {
  const startDate = dayjs().startOf('year').format('YYYY-MM-DD');
  const endDate = dayjs().endOf('month').format('YYYY-MM-DD');
  const [configAdvanced, setConfigAdvanced] = useState(false);

  const [open, setOpen] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  // const { data: summary, isError, refetch, isFetching, isFetched } = useConsolidationSummary();
  const [selectedYear, setSelectedYear] = useState(dayjs().year());
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [listYears, setListYears] = useState([]);

  const daysDiff = dayjs(selectedEndDate).diff(dayjs(selectedStartDate), 'day') || null;


  const filters = {
    ...(selectedYear && { year: selectedYear }),
    ...(selectedMonth && { month: selectedMonth }),
    ...(daysDiff !== null && { days: daysDiff }),
  };

  const { data: summary, isError, refetch, isFetching, isFetched } = useInadimplenciaHistoricalOverview(filters);


  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
  };

  const onApplyFilter = (selectedYear: number) => {
    setOpen(!!selectedYear);
  };

  return (
    <>
      <ImportCountDefault open={open} handleClose={handleClose} />

      <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
        <TitlePages title={'Visão histórica de inadimplência'} />

        <Stack flexDirection={'row'} gap={'20px'}>
          <Button
            sx={{
              p: '0 15px',
              borderRadius: '24px',
              fontSize: '14px',
              height: '30px',
              color: '#fff !important',
              weight: '700',
              background: '#15AB51',
              fontWeight: 700,
              textTransform: 'capitalize',
            }}
            variant="contained"
            // onClick={() => setConfigAdvanced(true)}/inadimplencia-configuracoes-avancadas-visao
            onClick={() => navigate('/inadimplencia-configuracoes-avancadas-visao')}
          >
            Configurações avançadas
          </Button>
        </Stack>
      </Stack>

      <Box
        padding={'15px'}
        sx={{
          border: '1px solid rgba(176, 176, 176, 1)',
          background: '#fff',
          borderRadius: '14px',
        }}
      >
        {isError && (
          <Alert
            severity="error"
            action={
              <Button
                color="inherit"
                size="small"
                onClick={() => {
                  refetch();
                }}
              >
                Atualizar
              </Button>
            }
          >
            Não foi possível carregar as informações!
          </Alert>
        )}

        {summary && isFetched && (
          <Stack flexDirection={'row'} gap={'8px'}>
            <Stack
              flexDirection="row"
              maxWidth="100%"
              gap="8px"
              style={{
                overflowX: 'auto',
                scrollBehavior: 'smooth',
                scrollbarWidth: 'thin',
                scrollbarColor: '#888 #f1f1f1',
              }}
            >
              <KpiComponent
                title={'Inadimplência'}
                value={CurrencyFormat.format(summary?.debits_in_year)}
                tooltipText={'Valor acumulado de todos os boletos inadimplentes no ano atual.'}
                style={{minWidth: '160px'}}
              />
              <KpiComponent
                title={'Quantidade de alunos em débito'}
                value={summary?.students_in_debit}
                tooltipText={'Quantidades de alunos com pelo menos um boleto em atraso no ano atual.'}
                style={{minWidth: '160px'}}
              />
              <KpiComponent
                title={'Quantidades de contas inadimplência'}
                value={`${summary?.debits_percentual}%`}
                tooltipText={'Relaciona Total a receber no ano e Total de boletos atrasados no ano corrente.'}
                style={{minWidth: '160px'}}
              />
            </Stack>
          </Stack>
        )}
        {isFetching && !summary && (<LoadingSummary />)}

        <Box marginTop={'10px'}>
          <PeriodFilterDash
            startDate={selectedStartDate}
            endDate={selectedEndDate}
            onStartDateChange={setSelectedStartDate}
            onEndDateChange={setSelectedEndDate}
            refetchDashboard={() => console.log('teste')}
            listYears={listYears}
            setSelectedYear={setSelectedYear}
            setSelectedMonth={setSelectedMonth}
            selectedYear={selectedYear}
            selectedMonth={selectedMonth}
            showMonthFilter={false}
            showPeriodFilter={false}
          />
        </Box>

        <Grid mt={'10px'} container spacing={2}>
          <Grid item xs={12}>
            <ScoreInadimplenciaCategoriaVisao
              year={parseInt(String(selectedYear))}
              month={selectedMonth} setListYears={setListYears}
            />
          </Grid>
        </Grid>

        <Grid mt={'10px'} container spacing={2}>
          <Grid item xs={12}>
            {/* <ColumnChart /> */}
            <ScoreInadimplenciaCategoriaVisaoAnual
              year={parseInt(String(selectedYear))}
              month={selectedMonth}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
